<template>
  <span
    class="course"
    data-test-id="education-course-element"
    :data-index="`${section}.${index}`"
    :data-name="course"
    @keydown.enter.stop.prevent="addCourse"
    @keydown.delete.stop="removeCourse"
  >
    <span
      v-editable="isEditable"
      data-test-id="education-course"
      :data-target-path="`resume.${section}.${index}`"
      class="name"
      v-text="course"
    ></span>

    <ItemActions
      data-test-id="education-course-actions"
      v-show="isEditable"
      :section="section"
      :index="index"
      :actions="['delete']"
      :confirm-delete="false"
    />
  </span>
</template>

<script setup lang="ts">
import { nextTick } from 'vue'
import ItemActions from './ItemActions.vue'

const emit = defineEmits(['add', 'remove'])

const { section, index } = defineProps<{
  course: string
  index: number
  section: string
  isEditable?: boolean
}>()

const addCourse = async event => {
  emit('add', index)

  await nextTick()

  const nextItem = event.currentTarget?.parentElement
    ?.querySelector(`span.course[data-index="${section}.${index + 1}"]`)
    ?.querySelector('span')

  if (nextItem) {
    focusElement(nextItem)
  }
}

const removeCourse = async event => {
  if (event.currentTarget?.querySelector('span')?.innerText.trim().length > 0) {
    return
  }
  event.preventDefault()
  const previousItem = event.currentTarget?.parentElement
    ?.querySelector(`span.course[data-index="${section}.${index - 1}"]`)
    ?.querySelector('span')

  setCursor(previousItem)
  emit('remove', index)
}

const setCursor = element => {
  if (!element) return
  element.focus()
  const range = document.createRange()
  const selection = window.getSelection()
  range.setStart(element, element.childNodes.length)
  range.setEnd(element, element.childNodes.length)
  range.collapse(true)
  selection?.removeAllRanges()
  selection?.addRange(range)
}

const focusElement = element => {
  element.focus()
  const selection = window.getSelection()
  selection?.removeAllRanges()
  const range = document.createRange()
  range.selectNodeContents(element)
  selection?.addRange(range)
}
</script>

<style lang="postcss" scoped>
.course {
  @apply leading-[inherit] inline-block mr-1-em relative min-w-[6px] h-auto;
  &:not(:last-child) {
    &:after {
      content: ',';
    }
  }
  .itemActions {
    @apply hidden;
  }
  &:hover {
    @apply bg-jsBlue-20;
    .itemActions {
      @apply flex;
    }
  }
}
</style>
